import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Card, Grid, Icon } from "@mui/material";
import MDBox from "shared/components/MDBox";
import MDTypography from "shared/components/MDTypography";
import MDButton from "shared/components/MDButton";
import CustomModal from "shared/components/MDmodal/CustomModal";
import FormDevice from "../Form/FormDevice";
import { createDeviceService } from "modules/bitacora/services/Configuracion/Equipo/equipoService";

const HeaderEquipo = ({ children, onDeviceCreated }) => {
  const [open, setOpen] = useState(false);

  const handleCreate = async (data) => {
    const created = await createDeviceService(data);
    onDeviceCreated(created);
    setOpen(false);
  };

  return (
    <MDBox position="relative" sx={{ mt: -2, mx: -3, py: 2, px: -2 }}>
      <Card sx={{ mt: 1, mx: 3, py: 2, px: 2 }}>
        <Grid container alignItems="center" justifyContent="space-between" spacing={3}>
          <Grid item>
            <MDTypography variant="h5" fontWeight="medium">
              Equipos
            </MDTypography>
          </Grid>
          <Grid item>
            <MDButton
              variant="gradient"
              color="success"
              startIcon={<Icon>add</Icon>}
              onClick={() => setOpen(true)}
            >
              Crear nuevo Equipo
            </MDButton>
          </Grid>
        </Grid>
        {children}
      </Card>
      <CustomModal open={open} onClose={() => setOpen(false)} title="Crear Equipo">
        <FormDevice onSubmit={handleCreate} afterSubmit={() => {}} />
      </CustomModal>
    </MDBox>
  );
};

HeaderEquipo.defaultProps = {
  children: "",
  onDeviceCreated: null,
};

HeaderEquipo.propTypes = {
  children: PropTypes.node,
  onDeviceCreated: PropTypes.func,
};

export default HeaderEquipo;
